module.exports = __webpack_public_path__ + "static/media/005_iOS - 5 - HOME.f73c90d5.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/screenshots/kp/005_iOS - 5 - HOME.png
// module id = 502
// module chunks = 0